import { useQuery } from "@tanstack/react-query";
import { useApi } from "hooks/useApi";
import { useProduct } from "contexts/ProductContext";

export const useProductRaw = () => {
  const api = useApi();
  const { product } = useProduct();
  const productId = product?.id;

  return useQuery({
    queryKey: ["product-raw", productId],
    queryFn: () => api.products.getProductRaw(productId!),
    enabled: !!productId,
  });
};
